<template>
  <v-card class="ma-0 pa-2">
    <div class="justify-center pt-2">Testing CS Form Dialog</div>

    <v-container>
      <v-row class="mb-3">
        <cs-button
          label="Open Form Dialog"
          @click="onShowPrimaryDialog('Dialog Title', 'This is a dialog subheading')"
        />
      </v-row>

      <v-row class="mb-3">
        <cs-button
          label="No subheading no actions"
          @click="onShowDialog('No Sub Heading Dialog', null)"
        />
      </v-row>
      <v-row class="mb-3">
        <cs-button
          label="No Heading (will not show)"
          @click="onShowDialog('', 'No Heading Dialog')"
        />
      </v-row>
      <v-row class="mb-3">
        <cs-button
          label="Long Text"
          @click="onShowLongTextDialog('Long Text dialog', 'This is a dialoge subheading')"
        />
      </v-row>
      <v-row class="mb-3">
        <cs-button label="Dialog with Delete and Secondary" @click="dialogDelete = true" />
      </v-row>
      <v-row class="mb-3">
        <cs-button label="Dialog with Delete and 2 Secondaries" @click="dialogDelete2 = true" />
      </v-row>
      <v-row class="mb-3">
        <cs-button
          label="Dialog with Secondary, Delete and Primary"
          @click="dialogDeletePrimary = true"
        />
      </v-row>
      <v-row class="mb-3">
        <cs-button
          label="Dialog exit 3 Buttons (will not show)"
          @click="dialogExtraButton = true"
        />
      </v-row>
    </v-container>

    <cs-form-dialog v-model="dialogNoSubHeading" id="form-dialog-1" :heading="heading">
      <template v-slot:cs-form-dialog-content>
        {{ dialogContent }}
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      v-model="dialog"
      id="form-dialog-2"
      :heading="heading"
      :subheading="subheading"
      :primaryAction="{
        label: 'Agree',
        eventName: 'dlg-ok',
        disabled: disablePrimary,
        loading: primaryActionLoading,
        rightIcon: 'mdi-check-circle'
      }"
      :secondaryAction1="{
        label: 'information alert',
        eventName: 'dlg-info',
        disabled: disableInfoAlert,
        leftIcon: 'mdi-information-outline'
      }"
      :secondaryAction2="{
        label: 'demonstrates action loading',
        eventName: 'dlg-warning',
        loading: secondaryActionLoading,
        leftIcon: 'mdi-gesture-tap'
      }"
      @dlg-ok="onDlgOkClick"
      @dlg-warning="onDlgWarningClick"
      @dlg-info="onDlgInfoClick"
    >
      <template v-slot:cs-form-dialog-content>
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Type here to enable buttons"
                  outlined
                  @input="onFormInput"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-combobox
                  v-model="select"
                  :items="['Programming', 'Design', 'Vue', 'Vuetify']"
                  label="Combobox"
                  multiple
                  outlined
                  dense
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-combobox
                  v-model="select"
                  :items="['Programming', 'Design', 'Vue', 'Vuetify']"
                  label="Combobox"
                  multiple
                  outlined
                  dense
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-combobox
                  v-model="select"
                  :items="['Programming', 'Design', 'Vue', 'Vuetify']"
                  label="Combobox"
                  multiple
                  outlined
                  dense
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-combobox
                  v-model="select"
                  :items="['Programming', 'Design', 'Vue', 'Vuetify']"
                  label="Combobox"
                  multiple
                  outlined
                  dense
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-combobox
                  v-model="select"
                  :items="['Programming', 'Design', 'Vue', 'Vuetify']"
                  label="Combobox"
                  multiple
                  outlined
                  dense
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-radio-group column>
                  <v-radio label="Option 1" value="radio-1">
                    <v-text-field label="Image Url" outlined></v-text-field>
                  </v-radio>
                  <v-radio label="Option 2" value="radio-2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-file-input label="File input" filled prepend-icon="mdi-camera"></v-file-input>
            </v-row>
          </v-container>
        </v-form>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      v-model="dialogDelete"
      id="form-dialog-delete"
      heading="Dialog with Delete and Secondary Button"
      :deleteAction="{
        label: 'Delete',
        eventName: 'dlg-delete',
        loading: deleteActionLoading,
        leftIcon: 'mdi-information-outline'
      }"
      :secondaryAction1="{
        label: 'Information',
        eventName: 'dlg-info'
      }"
      @dlg-delete="onDlgDeleteClick"
      @dlg-info="onDlgInfoClick"
    >
      <template v-slot:cs-form-dialog-content>
        Are you sure you want to proceed to delete?
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      v-model="dialogDelete2"
      id="form-dialog-delete2"
      heading="Dialog with Delete and 2 Secondaries Button"
      :deleteAction="{
        label: 'DELETE',
        eventName: 'dlg-delete'
      }"
      :secondaryAction1="{
        label: 'information alert',
        eventName: 'dlg-info'
      }"
      :secondaryAction2="{
        label: 'demonstrates action loading',
        eventName: 'dlg-warning',
        loading: secondaryActionLoading
      }"
      @dlg-delete="onDlgDelete2Click"
      @dlg-warning="onDlgWarningClick"
      @dlg-info="onDlgInfoClick"
    >
      <template v-slot:cs-form-dialog-content>
        Are you sure you want to proceed to delete?
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      v-model="dialogDeletePrimary"
      id="form-dialog-delete-primary"
      heading="Dialog with Delete and Primary Button"
      :primaryAction="{
        label: 'Continue',
        eventName: 'dlg-ok'
      }"
      :deleteAction="{
        label: 'Remove',
        eventName: 'dlg-remove'
      }"
      :secondaryAction1="{
        label: 'information alert',
        eventName: 'dlg-info'
      }"
      @dlg-remove="onDlgRemoveClick"
      @dlg-ok="onDlgDeletePrimaryOkClick"
      @dlg-info="onDlgInfoClick"
    >
      <template v-slot:cs-form-dialog-content>
        Clicks Continue to continue the updates, clicks Remove to remove the item.
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      v-model="dialogExtraButton"
      id="form-dialog-delete-primary"
      heading="Dialog with Extra Button"
      :primaryAction="{
        label: 'Continue',
        eventName: 'dlg-ok'
      }"
      :deleteAction="{
        label: 'Remove',
        eventName: 'dlg-remove'
      }"
      :secondaryAction1="{
        label: 'information alert',
        eventName: 'dlg-info'
      }"
      :secondaryAction2="{
        label: 'extra button',
        eventName: 'dlg-extra'
      }"
    >
      <template v-slot:cs-form-dialog-content>
        This dialog will not be shown due to more than 3 buttons!
      </template>
    </cs-form-dialog>
  </v-card>
</template>

<script>
import { CSFormDialog } from '@complispace/cs-design-system';

export default {
  components: { 'cs-form-dialog': CSFormDialog },
  name: 'FormDialogsTest',

  data() {
    return {
      dialog: false,
      dialogNoSubHeading: false,
      heading: 'testing',
      subheading: '',
      dialogContent: undefined,
      select: '',
      disablePrimary: true,
      disableInfoAlert: true,
      primaryActionLoading: false,
      secondaryActionLoading: false,
      dialogDelete: false,
      dialogDelete2: false,
      deleteActionLoading: false,
      dialogDeletePrimary: false,
      dialogExtraButton: false
    };
  },
  watch: {
    // whenever question changes, this function will run
    value(newVal) {
      console.log(newVal);
    }
  },

  methods: {
    onDlgOkClick() {
      this.primaryActionLoading = true;
      setTimeout(() => {
        this.primaryActionLoading = false;
        this.closeDialog();
      }, 5000);
    },
    closeDialog() {
      this.dialog = false;
      this.dialogNoSubHeading = false;
    },
    onDlgWarningClick() {
      this.secondaryActionLoading = true;
      setTimeout(() => {
        this.secondaryActionLoading = false;
        this.showDialogAlert('warning');
      }, 2000);
    },
    onDlgInfoClick() {
      this.showDialogAlert('info');
    },
    onDlgDeleteClick() {
      this.deleteActionLoading = true;
      setTimeout(() => {
        this.deleteActionLoading = false;
        this.showDialogAlert('Deleted');
        this.dialogDelete = false;
      }, 2000);
    },
    onDlgDelete2Click() {
      this.dialogDelete2 = false;
    },
    onDlgRemoveClick() {
      this.dialogDeletePrimary = false;
    },
    onDlgDeletePrimaryOkClick() {
      this.dialogDeletePrimary = false;
    },
    onFormInput(val) {
      if (val) {
        this.disablePrimary = false;
        this.disableInfoAlert = false;
      } else {
        this.disablePrimary = true;
        this.disableInfoAlert = true;
      }
    },
    showDialogAlert(type) {
      const message =
        'This configuration will prevent users from logging in via Ideagen Home’s authentication solution. Make sure all fields below are filled in correctly in order to prevent any login issues.';
      this.$store.commit('cs-appearance/setAlert', {
        type,
        message,
        onDialogOnly: true
      });
    },
    onShowDialog(headingText, subheadingText) {
      this.heading = headingText;
      if (subheadingText !== null) {
        this.subheading = subheadingText;
        this.dialog = true;
      } else {
        this.dialog = false;
        this.dialogNoSubHeading = true;
      }
      this.dialogContent = 'This is a simple text.....';
    },
    onShowPrimaryDialog(headingText, subheadingText) {
      // this.actionLoading = true;
      this.onShowDialog(headingText, subheadingText);
    },
    onShowLongTextDialog(headingText) {
      this.onShowDialog(headingText, null);
      this.dialogContent =
        'This is where long text goes. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborun. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat.';
    }
  }
};
</script>
